import { useEffect, useState } from 'react';
import useSubscriptions from '@afosto/utils-react/subscription/useSubscriptions';
import { logistics as logisticsApi } from '@afosto/wms/api/Logistics';

const useTransferItem = (transfer, claimId) => {
  const subscriptions = useSubscriptions();
  const hasWmsSubscription = subscriptions.some(subscription => subscription.code === 'wms');
  const [transferItem, setTransferItem] = useState([]);

  useEffect(() => {
    let isMounted = true;

    const fetchTransferItem = async () => {
      try {
        const response = await logisticsApi.getTransferTransportsItemsSummary(transfer, {
          claimId,
        });
        const { data } = response;
        const [firstItem] = data ?? [];

        if (isMounted) {
          setTransferItem(firstItem);
        }
      } catch (err) {
        setTransferItem(null);
      }
    };

    if (hasWmsSubscription && transfer && claimId) {
      fetchTransferItem();
    } else {
      setTransferItem(null);
    }

    return () => {
      isMounted = false;
    };
  }, [transfer, claimId, hasWmsSubscription]);

  return [transferItem, setTransferItem];
};

export default useTransferItem;
